import script from "./current-version.vue?vue&type=script&lang=ts&setup=true"
export * from "./current-version.vue?vue&type=script&lang=ts&setup=true"

import "./current-version.vue?vue&type=style&index=0&id=d861dbca&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d861dbca"]])

export default __exports__